import convertToSuperscript from '../../utils/converToSuperscript';

import styles from './styles.module.scss';

const RoomOption = ({
  accessory,
  idx,
  isSelected,
  handleSelect,
  toggledAccessory,
  setToggledAccessory,
  activeElementRef,
  isTutorialMode,
  t,
}) => {
  const {
    name,
    cta_copy,
    description,
    features,
    recommended_name,
    recommended_text,
    image_1,
    image_2,
    platformimagekey,
  } = accessory;

  const handleToggle = () => {
    setToggledAccessory(accessory === toggledAccessory ? null : accessory);
  };

  const handleDownload = (accessory) => {
    if (!accessory.cta_id && !accessory.cta_link) return;

    if (accessory.cta_id) {
      window.parent.postMessage(
        {
          name: 'cta',
          id: t(accessory.cta_id),
        },
        '*'
      );
    } else {
      window.open(accessory.cta_link);
    }

    // Adobe tracking
    if (window.globalLmd) {
      window.lmd = window.globalLmd;
      window.lmd.download = t(accessory.cta_copy);
      window._satellite.track('Download');
    }
  };

  if (toggledAccessory !== accessory && toggledAccessory !== null) return null;

  return (
    <li
      className={styles.option}
      key={idx}
      ref={idx === 0 && isTutorialMode ? activeElementRef : null}
    >
      {/* collapsed view  */}
      <div className={styles.initial}>
        <div className={styles.initial__text}>
          <span>{idx + 1}</span>
          <span>{t(name)}</span>
        </div>
        <div className={styles.initial__ctas}>
          <button
            className={`${styles.initial__heartButton} ${
              isSelected ? styles['initial__heartButton--selected'] : ''
            }`}
            onClick={() => handleSelect(accessory)}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='11.888'
              height='11.738'
              viewBox='0 0 12.88 11.738'
            >
              <path
                d='M72.059 70.4a4.335 4.335 0 0 0-2.665 1.382 4.335 4.335 0 0 0-2.665-1.382 2.318 2.318 0 0 0-2.529 2.529c0 2.529 5.194 7.427 5.194 7.427s5.194-4.91 5.194-7.427a2.312 2.312 0 0 0-2.529-2.529z'
                transform='translate(-63.45 -69.65)'
                style={{
                  fill: 'none',
                  stroke: '#1e0013',
                  strokeMiterlimit: '10',
                  strokeWidth: '1.5px',
                }}
              />
            </svg>
          </button>
          <button
            className={`${styles.initial__expandButton} ${
              toggledAccessory === accessory
                ? styles['initial__expandButton--expanded']
                : ''
            }`}
            onClick={handleToggle}
          ></button>
        </div>
      </div>

      {/* expanded view  */}
      {toggledAccessory === accessory && (
        <div className={styles.expanded}>
          {recommended_name && (
            <p className={styles.expanded__recommended}>
              {t(recommended_text)} <span>{t(recommended_name)}</span>
            </p>
          )}
          {image_1 || image_2 ? (
            <div className={styles.expanded__imagesContainer}>
              {image_1 && (
                <picture>
                  <source
                    srcSet={
                      process.env.PUBLIC_URL +
                      '/images_iax/products/' +
                      image_1 +
                      '.webp'
                    }
                    type='image/webp'
                  />
                  <source
                    srcSet={
                      process.env.PUBLIC_URL +
                      '/images_iax/products/' +
                      image_1 +
                      '.jpg'
                    }
                    type='image/jpg'
                  />
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      '/images_iax/products/' +
                      image_1 +
                      '.jpg'
                    }
                    title={image_1}
                    alt={image_1}
                  />
                </picture>
              )}
              {image_2 && (
                <picture>
                  <source
                    srcSet={
                      process.env.PUBLIC_URL +
                      '/images_iax/products/' +
                      image_2 +
                      '.webp'
                    }
                    type='image/webp'
                  />
                  <source
                    srcSet={
                      process.env.PUBLIC_URL +
                      '/images_iax/products/' +
                      image_2 +
                      '.jpg'
                    }
                    type='image/jpg'
                  />
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      '/images_iax/products/' +
                      image_2 +
                      '.jpg'
                    }
                    title={image_2}
                    alt={image_2}
                  />
                </picture>
              )}
            </div>
          ) : null}

          <p className={styles.expanded__description}>{t(description)}</p>
          {features && (
            <ul>
              {features.map((feature, idx) =>
                feature ? (
                  <li key={idx}>
                    <span></span>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: convertToSuperscript(feature),
                      }}
                    ></p>
                  </li>
                ) : null
              )}
            </ul>
          )}
          {platformimagekey && (
            <picture>
              <source
                srcSet={
                  process.env.PUBLIC_URL +
                  '/images_iax/platforms/' +
                  platformimagekey +
                  '.webp'
                }
                type='image/webp'
              />
              <source
                srcSet={
                  process.env.PUBLIC_URL +
                  '/images_iax/platforms/' +
                  platformimagekey +
                  '.png'
                }
                type='image/png'
              />
              <img
                className={styles.expanded__platformImage}
                src={
                  process.env.PUBLIC_URL +
                  '/images_iax/platforms/' +
                  platformimagekey +
                  '.png'
                }
                title={platformimagekey}
                alt={platformimagekey}
                style={{ height: platformimagekey === 'intel' ? '55px' : '' }}
              />
            </picture>
          )}

          <div className={styles.option__ctas}>
            <button
              className={`${styles.option__cta} ${styles['option__cta--secondary']}`}
              onClick={() => setToggledAccessory(null)}
            >
              {t('tool_ui.button.back_to_solutions')}
            </button>
            {cta_copy && (
              <button
                className={`${styles.option__cta} ${styles['option__cta--primary']}`}
                onClick={() => handleDownload(accessory)}
              >
                {`${t(cta_copy)} >`}
              </button>
            )}
          </div>
        </div>
      )}
    </li>
  );
};

export default RoomOption;
